import { Checkbox, InputLabel, MenuItem, Select } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import ListItemText from '@material-ui/core/ListItemText';
import FilterCard from 'Components/Editor/Details/Filters/FilterCard';
import EditorVideoDetection from 'Models/Videos/Detections/EditorVideoDetection';
import VideoDetectionPlacement from 'Models/Videos/VideoDetectionPlacement';
import * as React from 'react';
import { ReactElement, ReactNode } from 'react';
import { isNumberArray } from 'Utils/TypeGuards';

interface FilterCardPlacementsProps {
	placements: VideoDetectionPlacement[];
	selectedIds: number[] | null;
	onSelectedIdsChanged: (ids: number[] | null) => void;
	selectedDetections: EditorVideoDetection[];
}

const FilterCardPlacements = (props: FilterCardPlacementsProps): ReactElement => {
	const isChecked = props.selectedIds !== null;
	const placements = props.placements.sort((a, b) => a.name.localeCompare(b.name));

	const handleCheckedChanged = (checked: boolean): void => {
		const defaultValue = props.selectedDetections.map((x) => x.placementId);
		if (checked) props.onSelectedIdsChanged(defaultValue);
		else props.onSelectedIdsChanged(null);
	};

	const handlePlacementSelectionChanged = ({ target }: React.ChangeEvent<{ value: unknown }>): void => {
		if (isNumberArray(target.value)) props.onSelectedIdsChanged(target.value);
		else console.error(`expected number array but instead got 'target.value'`);
	};

	const renderValue = (selected: unknown): ReactNode => {
		if (!isNumberArray(selected)) return null;
		const placementNames = props.placements.filter((x) => selected.includes(x.id)).map((x) => x.name);
		return placementNames.join(', ');
	};

	return (
		<FilterCard name={'Select placements'} onCheckedChanged={handleCheckedChanged} isChecked={isChecked}>
			<FormControl fullWidth={true} margin="normal">
				<InputLabel id="editor-filter-placements-label">Placements</InputLabel>
				<Select
					labelId="editor-filter-placements-label"
					value={props.selectedIds ?? []}
					onChange={handlePlacementSelectionChanged}
					multiple={true}
					renderValue={renderValue}
				>
					{placements.map((x) => (
						<MenuItem value={x.id} key={x.id}>
							<Checkbox checked={props.selectedIds?.includes(x.id)} />
							<ListItemText primary={x.name} />
						</MenuItem>
					))}
				</Select>
			</FormControl>
		</FilterCard>
	);
};

export default FilterCardPlacements;
